import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import storage from '@/utils/storage'
import { toast } from 'react-toastify'

const AuthService = {
  resource: API_RESOURCE.AUTH,

  loginWithSiemensID: async (body) => {
    const { status, data } = await axios.post(`${API_RESOURCE.AUTH}/siemensid/token`, body)
    console.log(data)
    console.log(status)
    if (status === 200 && data.data) {
      toast.success('Login With Siemens ID Success')
      storage.setToken(data.data)
      setTimeout(() => {
        window.location.reload()
      }, 500)
    } else {
      throw new Error('Error In Login')
    }
    return data
  },

  requestPasswordReset: async ({ email }) => {
    const response = await axios.put(`${API_RESOURCE.AUTH}/requestPasswordReset`, { email })
    return response.data
  },

  resetPassword: async ({ password, userId, token }) => {
    const response = await axios.put(`${API_RESOURCE.AUTH}/resetPassword`, { password, userId, token })
    return response.data
  },

  verifyRecaptcha: async ({ captchaValue }) => {
    const response = await axios.post(`${API_RESOURCE.AUTH}/reCaptchaVerify`, { captchaValue })
    return response.data
  },

  loginWithEmailAndPassword: async (payload) => {
    const { status, data } = await axios.post(`/auth/email`, payload)

    if (data?.data?.token) {
      storage.setToken(data?.data?.token)
    } else {
      console.log(data, status)
      throw new Error('Error In Login')
    }
    return data
  },
}

export default AuthService
